import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const refCodeTerm: UpdatesConfig['Mutation'] = {
  refCodeTermCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('refCodeTerms', cache);
  },
  refCodeTermUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['refCodeTerms'], cache);
  },
};

export default refCodeTerm;
